import React, { Component } from 'react'
import NavigationContainer from './header/NavigationContainer'
import Content from '../components/Content'
import mockContent from '../mockcontent/contentUtility'
import Jumbotron from '../components/jumbotron'
import JumbotronFooter from '../components/JumbotronFooter'

class PageContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      siteSections: [
        {
          id: 1, area: 'profile', displayHeader: 'Profile', activeLink: true, content: mockContent(1), ref: React.createRef(), title: 'Profile'
        },
        {
          id: 2, area: 'experience', displayHeader: 'Experience', activeLink: false, content: mockContent(2), ref: React.createRef(),  title: 'More about my experience'
        },
        {
          id: 3, area: 'skills', displayHeader: 'Skills', activeLink: false, content: mockContent(3), ref: React.createRef(), title: 'More about my skills'
        },
        {
          id: 4, area: 'projects', displayHeader: 'Projects', activeLink: false, content: mockContent(4), ref: React.createRef(), title: 'More about projects that I have worked on'
        },
        {
          id: 5, area: 'contact', displayHeader: 'Contact me', activeLink: false, content: mockContent(5), ref: React.createRef(), title: 'How you can contact me'
        }]
    }
  }

  goToSection = section => {
    let updatedSiteSections = [...this.state.siteSections]

    // set current active link to false
    let currentActiveLinkIndex = updatedSiteSections.findIndex(x => x.activeLink)
    updatedSiteSections[currentActiveLinkIndex].activeLink = false

    // get index of new active link and replace element
    let newActiveLinkIndex = updatedSiteSections.findIndex(x => x.id === section.id)
    section.activeLink = true;
    updatedSiteSections[newActiveLinkIndex] = section

    this.setState({
      siteSections: updatedSiteSections
    })
    
    window.scrollTo({top: section.ref.current.offsetTop, behavior: "smooth"})
  }

  render () {
    return(
      <>
        <NavigationContainer goToSection={this.goToSection} menuItems={this.state.siteSections} />
        <Jumbotron />
        <JumbotronFooter />
        {
          this.state.siteSections.map((item) => {
            return <div ref={item.ref}>
              <Content text={item.content} title={item.title}/>
            </div>
          })
        }
      
      </>)
  }
}

export default PageContainer
